import React from 'react'
import PropTypes from 'prop-types'
import { Carousel, WingBlank } from 'antd-mobile'
import { goIndex } from '../assets/js/utils'
class VSwiper extends React.Component {
    static propTypes = {
        data: PropTypes.object,
        templateType: PropTypes.string
    };

    render () {
        let {
            data: { position, sublist, trackId, style = {} },
            templateType,
            buriedPointEvent
        } = this.props
        if (!style) style = {}
        let { height = 100, offset, paddingBottom, paddingTop } = style
        // 后端传过来null,默认给10
        offset = offset ? Number(offset) : 10
        // 后端传过来0, 默认给-10
        offset = offset === 0 ? -10 : offset
        const bgColor = offset > 0 ? 'rgba(255, 255,255, .6)' : 'rgba(80,80,80, 0.6)'
        return (
            <WingBlank style={{
                height: `${(height || 100) / 37.5}rem`,
                margin: `${paddingTop ? paddingTop / 75 : 0}rem ${templateType === 'TPL_BANNER_MARGIN'
                    ? 40 / 75 + 'rem' : 0} ${paddingBottom ? paddingBottom / 75 : 0}rem`
            }}>
                <Carousel
                    autoplay={true}
                    infinite
                    dots={true}
                    dotStyle={{
                        width: `${20 / 75}rem`,
                        height: 6 / 75 + 'rem',
                        borderRadius: 3 / 75 + 'rem',
                        background: bgColor,
                        transform: `translate(0, ${(5 - offset) / 37.5}rem)`
                    }}
                    dotActiveStyle={{
                        width: `${50 / 75}rem`,
                        height: 6 / 75 + 'rem',
                        borderRadius: 3 / 75 + 'rem',
                        background: bgColor,
                        transform: `translate(0, ${(5 - offset) / 37.5}rem)`
                    }}
                >
                    {sublist.map((val, index) => (
                        <div
                            className={'statistics-dom'}
                            key={val.id}
                            onClick={() => {
                                buriedPointEvent({
                                    button_name: `${trackId}-${val.title}`,
                                    button_id: `${val.id}`,
                                    button_order: `${index + 1}`,
                                    area_order: position,
                                    button_area: `${position}-${trackId}`
                                })
                                goIndex(val.url, trackId, val.keyword, val)
                            }}
                            style={{
                                height: height * 2 / 75 + 'rem'
                            }}
                        >
                            <img
                                src={val.imageUrl}
                                alt={val.title}
                                style={{
                                    width: '100%',
                                    height: height * 2 / 75 + 'rem'
                                }}
                                onLoad={() => {
                                    window.dispatchEvent(new Event('resize'))
                                }}
                            />
                        </div>
                    ))}
                </Carousel>
            </WingBlank>
        )
    }
}

export default VSwiper
